import { Link } from "react-router-dom";
import { Clock, Lock } from "lucide-react";
import { motion } from "framer-motion";

const DEFAULT_IMAGES = [
  "https://images.unsplash.com/photo-1599008634438-fc6d2be54835?w=600&q=80",
  "https://images.unsplash.com/photo-1593425546383-260c8b86730b?w=600&q=80",
  "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?w=600&q=80",
];

export default function PostCard({ post, index = 0 }) {
  const coverImage =
    post.cover_image ||
    DEFAULT_IMAGES[index % DEFAULT_IMAGES.length];

  const formattedDate = post.published_at
    ? new Date(post.published_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })
    : "Draft";

  return (
    <motion.article
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.45, ease: "easeOut" }}
      className="group bg-card border border-border rounded-lg overflow-hidden hover:-translate-y-1 hover:shadow-md transition-all duration-300"
      data-testid={`post-card-${post.slug}`}
    >
      <Link to={`/post/${post.slug}`} className="block">
        {/* Cover Image */}
        <div className="relative aspect-[16/9] overflow-hidden bg-muted">
          <img
            src={coverImage}
            alt={post.title}
            className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-500"
            loading="lazy"
          />
          {post.visibility === "paid" && (
            <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full bg-brand-accent text-white text-xs font-medium font-manrope">
              <Lock size={11} />
              <span>Premium</span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-5">
          {/* Tags */}
          {post.tags && post.tags.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mb-3">
              {post.tags.slice(0, 3).map((tag) => (
                <span
                  key={tag}
                  className="overline text-brand-accent"
                >
                  {tag}
                </span>
              ))}
            </div>
          )}

          <h2 className="font-cormorant text-xl sm:text-2xl font-semibold leading-snug text-foreground mb-2 group-hover:text-brand-accent transition-colors duration-200 line-clamp-2">
            {post.title}
          </h2>

          <p className="font-manrope text-sm text-muted-foreground leading-relaxed line-clamp-3 mb-4">
            {post.excerpt}
          </p>

          {/* Meta */}
          <div className="flex items-center gap-3 text-muted-foreground">
            <span className="font-manrope text-xs">{formattedDate}</span>
            <span className="text-xs">·</span>
            <span className="flex items-center gap-1 font-manrope text-xs">
              <Clock size={12} />
              {post.reading_time || 3} min read
            </span>
          </div>
        </div>
      </Link>
    </motion.article>
  );
}
